import { render, staticRenderFns } from "./RelProdutividade.vue?vue&type=template&id=55b7ff30&shadow"
import script from "./RelProdutividade.vue?vue&type=script&lang=js&shadow"
export * from "./RelProdutividade.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./RelProdutividade.vue?vue&type=style&index=0&lang=css&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  ,true
)

export default component.exports